<template>
    <div>
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Réservation (visual pos)</h1>
                    <p>Gestion des réservations</p>
                </div>

                <div class="actions">
                    <ul>
                        <!--<li><button><span>Importer</span></button></li>-->
                        <li><button-action  type="create"/></li>
                    </ul>
                </div>

            </div>
        </header>
        <div class="content-body">

            <section>
                <!--
            <div class="search">
                <div><input type="text" placeholder="Recherche" v-model="query"/></div>
                <div>
                    <ul>
                        <li><button><span>Menu 1</span></button></li>
                        <li><button><span>Menu 1</span></button></li>
                        <li><button><span>Menu 1</span></button></li>
                    </ul>
                </div>
            </div>
            -->

            <h2 class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

            <div class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div v-bind:class="[ paginator.sort == 'name' ? 'active' : '', paginator.order ]">
                            <span data-sort="name" @click="setOrder($event)">Prénom</span>
                        </div>
                        <div><span>Email</span></div>
                        <div><span>Register page</span></div>
                        <div><span>Scope</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)">
                        <div></div>
                        <div class="picture">
                            <figure>
                                <i v-if="!item.picture" class="icon icon-icon_home"></i>
                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                            </figure>
                        </div>
                        <div data-field="name"><strong>{{ item.firstname }} {{ item.lastname }}</strong></div>
                        <div data-field="email">{{ item.email }}</div>
                        <div data-field="url"><a :href="item.register_url" target="_blank" :title="item.register_url"><i class="icon icon-icon_earth"></i></a></div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul>
                                <li v-if="item.policies && item.policies.delete"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="item.policies && item.policies.update"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import ReservationService from './ReservationService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return ReservationService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/checkin/reservation/Index.vue